import { createConfig } from "@commonlibs";
import lightTheme from "./theme/lightTheme";
import { config } from "common/config";
import { componentsConfig as components } from "./theme/components/componentsConfig";

const uiConfig = createConfig({
    projectName: config.projectName,
    themes: {
        default: lightTheme,
    },
    components,
});

export default uiConfig;
